import ActionButton from 'lib/src/components/button/ActionButton';
import ButtonRow from 'lib/src/components/button/ButtonRow';
import { useState } from 'react';
import { AssessmentScoreResponse, AssessmentSummary } from 'src/types/shared/Assessments';
import { getColor } from 'lib/src/utils/generic';

const ScoreSummaryExtraRows = ({ row }: ExtraRowsProps) => {
    const [currentRow, setCurrentRow] = useState<number | null>(null);

    const columns = [
        {
            key: 1,
            heading: 'Submission',
            getValue: (row: AssessmentScoreResponse) =>
                `${row.assessor.firstName} ${row.assessor.lastName}` || '-',
        },
        {
            key: 2,
            heading: 'Deployment timescale',
            getValue: (row: AssessmentScoreResponse) =>
                `${row.assessment.deploymentScale}/5 (${row.score.deploymentScale + ' pts'})` ||
                '-',
        },
        {
            key: 3,
            heading: 'Fit with challenge',
            getValue: (row: AssessmentScoreResponse) =>
                `${row.assessment.fitWithChallenge}/5 (${row.score.fitWithChallenge + ' pts'})` ||
                '-',
        },
        {
            key: 4,
            heading: 'Credibility of company',
            getValue: (row: AssessmentScoreResponse) =>
                `${row.assessment.credibilityCompany}/5 (${
                    row.score.credibilityCompany + ' pts'
                })` || '-',
        },
        {
            key: 5,
            heading: 'Credibility of technology',
            getValue: (row: AssessmentScoreResponse) =>
                `${row.assessment.credibilityTechnology}/5 (${
                    row.score.credibilityTechnology + ' pts'
                })` || '-',
        },
        {
            key: 6,
            heading: 'Full or partial solution',
            getValue: (row: AssessmentScoreResponse) =>
                `${row.assessment.fullOrPartialSolution}/5 (${
                    row.score.fullOrPartialSolution + ' pts'
                })` || '-',
        },
        {
            key: 7,
            heading: 'Is it innovative?',
            getValue: (row: AssessmentScoreResponse) =>
                !!row.assessment.isInnovative ? 'Yes' : 'No',
        },
        {
            key: 8,
            heading: 'Score',
            getValue: (row: AssessmentScoreResponse) => (
                <span className={getColor(row.score.total)}>
                    {`${row.score.total + ' pts'}` || '-'}
                </span>
            ),
        },
        {
            key: 9,
            heading: 'Summary',
            getValue: (row: AssessmentScoreResponse) =>
                !!row.assessment.finalComment ? `${row.assessment.finalComment}` : '-',
        },
        {
            key: 10,
            heading: '',
            getValue: (row: AssessmentScoreResponse) => {
                return (
                    <ButtonRow>
                        <ActionButton
                            color="grey"
                            icon={currentRow === row.assessment.id ? 'compress-alt' : 'expand-alt'}
                            type="button"
                            onClick={() => _setCurrentRow(row.assessment.id)}
                        ></ActionButton>
                    </ButtonRow>
                );
            },
        },
    ];

    return (
        <>
            {!!row.assessmentScores.length ? (
                row.assessmentScores.map((row, i) => {
                    return (
                        <tr
                            className={`extra-rows ${
                                currentRow === row.assessment.id ? 'expanded' : ''
                            } ${i % 2 === 0 ? 'shaded' : ''}`}
                        >
                            {columns.map(col => (
                                <td className="extra-cell" key={col.key}>
                                    {col.getValue(row)}
                                </td>
                            ))}
                        </tr>
                    );
                })
            ) : (
                <tr className={`extra-rows expanded shaded`}>
                    {Array(Math.round(columns.length / 2) - 1)
                        .fill(null)
                        .map((_: null, i: number) => (
                            <td key={`nd-${i}`} className="extra-cell" />
                        ))}
                    <div className="extra-cell no-data-cell">No submissions to show</div>
                    {Array(Math.floor(columns.length / 2))
                        .fill(null)
                        .map((_: null, i: number) => (
                            <td key={`nd-${i}`} className="extra-cell" />
                        ))}
                </tr>
            )}
        </>
    );

    function _setCurrentRow(id: number) {
        if (currentRow === id) setCurrentRow(null);
        else setCurrentRow(id);
    }
};

interface ExtraRowsProps {
    row: AssessmentSummary;
    length?: number;
}

export default ScoreSummaryExtraRows;
